import PubSub from 'pubsub-js';
import { usePrequalCookie, useLocalStorage } from './EirPrequalPersistance';
import { SPEEDLINE_PATTERN, EIRCODE_PATTERN } from './Constants';

  const { getLocalStorage,setLocalStorage} =
    useLocalStorage();

const checkPrequalForm = () => {
    let currentContext = getLocalStorage('currentContext');
    let updatedContext;
    if(currentContext.includes('opencms/export/sites/default/')){
    updatedContext = currentContext.replace('opencms/export/sites/default/', '/')
    }
    else{
     updatedContext = '/'.concat(getLocalStorage('currentContext'))
    }
    return updatedContext;
  }
const getContext = () => {
    const { getCookie } = usePrequalCookie();
    const eirClickedContext = getCookie('eir_clicked_context');
    const contexts = {
        tv: 'tv',
        mobile: 'mobile',
        generic: 'generic',
        broadband: 'broadband',
    };
    if (eirClickedContext) {
        return eirClickedContext.toLowerCase();
    } else if (window.location.href.toLowerCase().indexOf(contexts.broadband) > -1) {
        return contexts.broadband;
    } else if (window.location.href.toLowerCase().indexOf(contexts.tv) > -1) {
        return contexts.tv;
    } else if (window.location.href.toLowerCase().indexOf(contexts.mobile) > -1) {
        return contexts.mobile;
    }
    return contexts.generic;
};
const getSpeed = () => {
    const { getLocalStorage } = useLocalStorage();
    const { setCookie } = usePrequalCookie();
    let data = getLocalStorage('eir_prequal_data');
    if (data) {
        let speedLine;
        let finalSpeed;

            if(data.error)
            {
                return {finalspeed: '', error: data.error}
            }
            if(data.inga)
            {
                if(data.inbi && data.iftc && !data.ifth){
                    speedLine = data.maxNBI;
                }
                else {
                    speedLine = data.maxHSI;
                }
            }else if(data.inbi)
            {
                speedLine = data.maxNBI;
            }
            else if(data.ingb)
            {
                speedLine = data.maxNGB;
            }
            else if(data.idsl)
            {
                speedLine = data.maxDSL;
            }

        let matched = speedLine.match(SPEEDLINE_PATTERN);
        
        if (matched.length > 0) {
            let lineSpeed = matched[1] >=1000 ? (matched[1]/1000):matched[1];
            
            let unit = matched[2] == 'M' ? (matched[1] >=1000 ? 'Gb':'Mb') : 'Kb';
            finalSpeed = `${lineSpeed}${unit}`;
            setCookie('eir_prequal_bb_speed',finalSpeed);
        }

        return { finalspeed: finalSpeed, error: null };
    }
};

const scrollToTop = () => {
    const { getLocalStorage } = useLocalStorage();
    if(!getLocalStorage('eir_prequal_data'))
    {
        // window.scrollTo({
        //     top: 0,
        //     left: 0,
        //     behavior: 'smooth',
        // });
        PubSub.publish('SCROLL_TOP');
    }
};

// function to display address in required format
const formatAddress = (option) => {
    let addressLine1 = '',
        addressLine2 = '',
        addressLine3 = '',
        town = '',
        county = '';
    if (option.addressLine1) {
        addressLine1 = option.addressLine1
            .toLowerCase()
            .split(' ')
            .map(s => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
    }

    if (option.addressLine2) {
        addressLine2 = option.addressLine2
            .toLowerCase()
            .split(' ')
            .map(s => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
        addressLine2 = ', ' + addressLine2;
    }
    if (option.addressLine3) {
        addressLine3 = option.addressLine3
            .toLowerCase()
            .split(' ')
            .map(s => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
        addressLine3 = ', ' + addressLine3;
    }
    if (option.town) {
        town = option.town
            .toLowerCase()
            .split(' ')
            .map(s => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
        town = ', ' + town;
    }
    if (option.county) {
        {
            county = option.county;
            county = county.slice(3);
            county = county
                .toLowerCase()
                .split(' ')
                .map(s => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');
            county = ', ' + county;
        }
    }
    return addressLine1 + addressLine2 + addressLine3 + town + county;
}

//function for Eircode validation
const validateEircode = eircode => {
    var pattern = EIRCODE_PATTERN;

    let reg = new RegExp(pattern, 'i');
    let i = String(eircode).search(reg);
    if (i != -1)
        return String(eircode)
            .substring(i, i + 8)
            .toUpperCase()
            .replace(' ', '')
            .replace(/O/g, 0)
            .replace(/S/g, 5)
            .replace(/B/g, 8);
    else return '';
};

export { getContext, getSpeed, scrollToTop , formatAddress, validateEircode,checkPrequalForm };
